module.exports = __webpack_public_path__ + "static/media/fig_7a.326fd7e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_7a.jpg
// module id = 680
// module chunks = 0